export default "__VITE_ASSET__B2$fctnv__"